import { render } from "./SuspendedAccountDialogComponent.vue?vue&type=template&id=3354e6c7"
import script from "./SuspendedAccountDialogComponent.vue?vue&type=script&lang=js"
export * from "./SuspendedAccountDialogComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__